import { render, staticRenderFns } from "./MediaControlsAudio.vue?vue&type=template&id=5f667f9e&scoped=true&"
import script from "./MediaControlsAudio.vue?vue&type=script&lang=js&"
export * from "./MediaControlsAudio.vue?vue&type=script&lang=js&"
import style0 from "./MediaControlsAudio.vue?vue&type=style&index=0&id=5f667f9e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f667f9e",
  null
  
)

export default component.exports